import React from "react";
import "../../css/page.css";
import { /*Link,*/ Header, HeaderLogo, /*Dropdown, HeaderTitle*/ } from "../../styles/base";
import header_logo from "../../assets/img/header_logo.svg";
// import _ from "lodash";
// import translations from "../../locales";
// import getLocale from "../../helpers/getLocale";

export class AppHeader extends React.Component {
  render() {
    // const locale = getLocale();
    // const title = _.get(
    //   translations[locale],
    //   "it_rsvp_30th_anniv.app_header.title"
    // );
    return (
      <Header>
        <HeaderLogo>
          <img className="img-responsive" src={header_logo} alt="header logo" />
        </HeaderLogo>
        {/* <HeaderTitle>
          {title}
        </HeaderTitle> */}
        {/* <div className="header__locale-menu">
          <Dropdown>
            <Link
              className="dropdown__label"
              onClick={this.props.openLanguageSwitcher}
            >
              <span lang="en">EN</span>
              <span lang="zh-CN">中文</span>
            </Link>
          </Dropdown>
        </div> */}
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/app_header/app_header.js